import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0a0a10] pb-24">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <Logo className="h-7 w-auto mb-4" />
        <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
          Independent electronic record label. The frequency of the underground, distributed worldwide.
        </p>
      </div>
      <div>
        <h4 className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-slate-500 mb-4">Platforms</h4>
        <ul className="space-y-2">
          {[
            ["Spotify", "https://open.spotify.com"],
            ["Apple Music", "https://music.apple.com"],
            ["YouTube Music", "https://music.youtube.com"],
            ["SoundCloud", "https://soundcloud.com"],
            ["Beatport", "https://www.beatport.com"],
          ].map(([l, h]) => (
            <li key={l}>
              <a data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`} href={h} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-[#00f0ff] transition-colors">{l}</a>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-slate-500 mb-4">Contact</h4>
        <p className="font-mono-tech text-sm text-[#00ff66]">demos@r-an.app</p>
        <p className="text-sm text-slate-500 mt-2">For demo submissions use the artist form above.</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 font-mono-tech text-[10px] tracking-[0.25em] uppercase text-slate-600">
        <span>© 2026 R-AN Records — r-an.app</span>
        <span className="text-[#ff0055]">All frequencies reserved</span>
      </div>
    </div>
  </footer>
);
